import { FC, RefObject } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ScrollContainer } from '@ebsco-ui/ebsco-ui';

import {
  AvailabilityProvider,
  MappingsProvider,
  SearchProvider,
} from '@app/components';
import {
  AppContext,
  AppContextProps,
  FeatureFlag,
  SearchContextProps,
} from '@app/contexts';

import { MainContentContainer } from './MainContentContainer';

interface ProviderRootProps {
  appContext: AppContextProps;
  searchContext?: Partial<SearchContextProps>;
  featureFlags?: FeatureFlag[];
}

export const ProviderRoot: FC<ProviderRootProps> = ({
  appContext,
  searchContext,
  children,
}) => (
  <AppContext.Provider value={appContext}>
    <HelmetProvider>
      <SearchProvider searchContext={searchContext}>
        <MappingsProvider>
          <AvailabilityProvider>
            <ScrollContainer
              renderContainer={({ ...rest }, ref) => (
                <MainContentContainer
                  scrollRef={ref as RefObject<HTMLDivElement>}
                  {...rest}
                />
              )}
            >
              {children}
            </ScrollContainer>
          </AvailabilityProvider>
        </MappingsProvider>
      </SearchProvider>
    </HelmetProvider>
  </AppContext.Provider>
);
